<template>
<div>
    <div class="branch-line">
        <div class="header">
            <h3 v-text="strings.heading"></h3>
            <div class="actions">
                <i v-if="can.clone" @click="cloneBranch" class="fa fa-files-o" aria-hidden="true"></i>
                <i v-if="can.delete" @click="removeBranch" class="fa fa-trash" aria-hidden="true"></i>
            </div>
        </div>

        <div v-if="main && mainSegmentUid">
            <seismic-line-segment
                :uid="mainSegmentUid"
                :mainBranch="true">
            </seismic-line-segment>

            <div class="header">
                <h3>Segments</h3>
            </div>

            <seismic-line-segment
                v-for="uid in supplementarySegmentUids"
                :key="uid"
                :uid="uid"
                :mainBranch="true">
            </seismic-line-segment>
        </div>

        <div v-else>
            <seismic-line-segment
                v-for="uid in segmentUids"
                :key="uid"
                :uid="uid">
            </seismic-line-segment>
        </div>

        <!-- @update:data="val => segment = val" -->

        <p class="messaging error simple" v-if="main && mainBranchLengthErrors.length" v-for="error in mainBranchLengthErrors" v-text="error"></p>

        <p class="messaging error simple" v-if="record.riserNippleError" v-text="strings.riserNippleError"></p>

        <span class="add-segment" @click="addSegment()">
            <i class="fa fa-plus"></i>
            Add a Segment
        </span>
        <span class="add-segment" @click="addRiserNipple" v-if="!main && !riserNippleUid">
            <i class="fa fa-plus"></i>
            Add a Riser Nipple
        </span>
    </div>
    <div class="total subtotal">
        <fieldset v-show="!main">
            <div class="text">
                <label for="total" v-text="strings.copies"></label>
                <input type="text" id="total" v-model="localData.copies">
            </div>
        </fieldset>
        <fieldset v-show="!main">
            <div class="text">
                <label for="total" v-text="strings.weight"></label>
                <span v-if="record.weight" v-text="lbOrKg(record.weight, true)"></span>
                <span v-else>--</span>
            </div>
        </fieldset>
        <fieldset>
            <div class="text">
                <label for="total" v-text="strings.totalWeight"></label>
                <span v-if="record.totalWeight" v-text="lbOrKg(record.totalWeight, true)"></span>
                <span v-else>--</span>
            </div>
        </fieldset>
    </div>
</div>
</template>

<script>
import SeismicLineSegment from './line-segment';

import { mapKeyedGetters } from '../../../common/vuex-extra';
import { mapGetters } from 'vuex';

export default {
    name: 'seismic-branch-line',

    components: {
        SeismicLineSegment
    },

    props: [
        'uid'
    ],

    data() {
        return {
            localData: {}
        };
    },

    mounted() {
        this.localData = Object.assign({}, this.record);
    },

    watch: {
        localData: {
            handler() {
                this.$store.dispatch('seismicSystem/setBranch', this.localData);
            },
            deep: true
        },
    },

    computed: {
        ...mapKeyedGetters({
            'record': 'seismicSystem/branch',
            'index': 'seismicSystem/branchIndex',
            'mainSegmentUid': 'seismicSystem/mainSegmentUid',
            'supplementarySegmentUids': 'seismicSystem/supplementarySegmentUids',
            'segmentUids': 'seismicSystem/segmentUids',
            'normalSegmentUids': 'seismicSystem/normalSegmentUids',
            'riserNippleUid': 'seismicSystem/riserNippleUid',
        }),

        ...mapGetters({
            "mainBranchLengthErrors": "seismicSystem/mainBranchLengthErrors"
        }),

        main() {
            return this.index === 0;
        },

        strings() {
            return {
                heading: `Define ${this.name}`,
                copies: `# of ${this.name}'s`,
                weight: `${this.name} Weight`,
                totalWeight: `${this.name} Total Weight`,
                riserNippleError: 'Riser Nipple and Branch Line Require Further Bracing'
            };
        },

        can() {
            return {
                clone: !this.main,
                delete: !this.main
            }
        },


        name() {
            if (this.index === 0) {
                return 'Main Line'
            } else {
                return `Branch Line ${this.index}`
            }
        },

    },

    methods: {
        addSegment() {
            this.$store.dispatch('seismicSystem/addSegment', {
                uid: this.localData.uid,
            });
        },

        addRiserNipple() {
            this.$store.dispatch('seismicSystem/addSegment', {
                uid: this.localData.uid,
                data: { riserNipple: true }
            });
        },

        cloneBranch() {
            this.$store.dispatch('seismicSystem/cloneBranch', this.localData);
        },

        removeBranch() {
            this.$store.dispatch('seismicSystem/removeBranch', this.localData);
        }
    }
}
</script>
